module.exports = __webpack_public_path__ + "static/img/small_logo_white.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/small_logo_white.png
// module id = FDHq
// module chunks = 0